/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_HeadlineInputs */

const he_landing_headline = /** @type {(inputs: Landing_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בנו את ה-SaaS שלכם מהר יותר`)
};

const en_landing_headline = /** @type {(inputs: Landing_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build your SaaS faster`)
};

/**
* | output |
* | --- |
* | "Build your SaaS faster" |
*
* @param {Landing_HeadlineInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_headline = /** @type {((inputs?: Landing_HeadlineInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_HeadlineInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_landing_headline(inputs)
	return en_landing_headline(inputs)
});